import styled from "styled-components";
import { Button } from "antd";

export const StyledButton = styled(Button)`
  &.renderbus-ui--button {
    font-size: 14px !important;
    &:hover {
      color: #ffffff !important;
      background-color: default !important;
      border-color: transparent !important;
    }
    &.ant-btn-ghost {
      border-color: var(--main-color);
      color: var(--main-color);
      &::before {
        background: transparent;
      }
      &.ant-btn-loading,
      &[disabled],
      &[disabled]:hover {
        background-color: transparent !important;
        border-color: rgba(255, 255, 255, 0.35) !important;
        color: rgba(255, 255, 255, 0.35);
      }
    }
    &.ant-btn-default {
      background-color: #5c5d5f;
      border-radius: 4px;
      border-color: transparent;
      &:focus,
      &:hover {
        color: #fff;
      }
    }
    &.modify-btn {
      &:focus,
      &:hover {
        color: var(--main-color) !important;
      }
    }
    &.ant-btn-primary {
      background-color: var(--main-color);
      border-color: var(--main-color);
      border-radius: 4px;
      &:hover {
        background-color: var(--main-color);
      }
      &[disabled]:hover {
        background-color: var(--main-color) !important;
      }
    }
    &[disabled],
    &[disabled]:hover {
      border: 1px solid rgba(255, 255, 255, 0.1);
      color: rgba(255, 255, 255, 0.35) !important;
    }
    &.ant-btn-text {
      &:hover {
        color: var(--color-main-help);
        background: transparent;
      }
    }
    &.ant-btn-text[disabled] {
      border: unset;
    }
    &.table-text-btn {
      color: var(--main-color);
      padding: 0;
    }

    &.outline {
      border: 1px solid var(--main-color);
      border-radius: 4px;
      color: var(--main-color);
      background-color: transparent;
    }
  }
`;
